<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi01">
<a id="page11">
<div class="epigraph">
<p class="epigraphText">“If you bring forth what is within you, what you bring forth will save you. If you do not bring forth what is within you, what you do not bring forth will destroy you.”</p>
<p class="epigraphSource">—T<span class="smallCaps">HE</span> G<span class="smallCaps">OSPEL OF</span> T<span class="smallCaps">HOMAS</span>, V<span class="smallCaps">ERSE</span> 70</p>
</div>
</a><a id="page12">
</a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416995050_epi01.vue?e03e8da4